import { Routes, Route } from "react-router-dom";

import { RouteConstants } from "constant";

import WelcomePage from "pages/public/welcome";
import LoginPage from "pages/public/login";

import RegistrationVerifyCode from "pages/public/registration/verify-code";
import RegistrationSetPassword from "pages/public/registration/set-password";

import CardListPage from "pages/cards/list";
import CardViewPage from "pages/cards/view";

import ClientListPage from "pages/clients/list";
import ClientViewPage from "pages/clients/view";
import MyCLientsPage from "pages/clients-my/list";
import CLientNewPage from "pages/clients/new";

import ChatPage from "pages/chat";

import UsersListPage from "pages/users/list";
import UserRecommendationListPage from "pages/recommendations/list";
import ProfilePage from "pages/profile";

import ControlPage from 'pages/control';
import TodoListPage from 'pages/todo/list';
import PermissionsPage from 'pages/permissions';
import TemplateFormPage from 'pages/permissions/templates/TemplateFormPage';
import AgentPermissionsPage from 'pages/permissions/agents/AgentPermissionsPage';

import Error404Page from "pages/error/404";
import Error406Page from "pages/error/406";
import Error500Page from "pages/error/500";
import Error503Page from "pages/error/503";


const CustomRouter = () => {
  return (
    <Routes>
      <Route path={"/"} element={<WelcomePage />} />
      <Route path={RouteConstants.ROUTE_LOGIN} element={<LoginPage />} />
      <Route path={RouteConstants.ROUTE_DASHBOARD} element={<ClientListPage />} />

      <Route path={RouteConstants.ROUTE_REGISTRATION + "/mail-bestätigen"} element={<RegistrationVerifyCode />} />
      <Route path={RouteConstants.ROUTE_REGISTRATION + "/passwort-festlegen"} element={<RegistrationSetPassword />} />

      <Route path={RouteConstants.ROUTE_CHAT} element={<ChatPage />} />

      <Route path={RouteConstants.ROUTE_CARDS} element={<CardListPage />} />
      <Route path={RouteConstants.ROUTE_CARDS + "/:id"} element={<CardViewPage />} />
      <Route path={RouteConstants.ROUTE_CARDS} element={<CardListPage />} />

      <Route path={RouteConstants.ROUTE_CLIENTS} element={<ClientListPage />} />
      <Route path={RouteConstants.ROUTE_CLIENTS + "/:id"} element={<ClientViewPage />} />
      <Route path={RouteConstants.ROUTE_MY_CLIENTS} element={<MyCLientsPage />} />
      <Route path={RouteConstants.ROUTE_CLIENTS_NEW} element={<CLientNewPage />} />

      <Route path={RouteConstants.ROUTE_USERS} element={<UsersListPage />} />
      <Route path={RouteConstants.ROUTE_USER_RECOMMENDATIONS} element={<UserRecommendationListPage />} />
      <Route path={RouteConstants.ROUTE_PROFILE} element={<ProfilePage />} />
      <Route path={RouteConstants.ROUTE_PROFILE + "/:id"} element={<ProfilePage />} />

      <Route path={RouteConstants.ROUTE_CONTROL} element={<ControlPage />} />
      <Route path={RouteConstants.ROUTE_TODO} element={<TodoListPage />} />
      <Route path={RouteConstants.ROUTE_PERMISSIONS} element={<PermissionsPage />} />
      <Route path={RouteConstants.ROUTE_PERMISSIONS + "/sabloni/:id"} element={<TemplateFormPage />} />
      <Route path={RouteConstants.ROUTE_PERMISSIONS + "/agenti/:id"} element={<AgentPermissionsPage />} />

      <Route path={RouteConstants.ROUTE_ERROR_406} element={<Error406Page />} />
      <Route path={RouteConstants.ROUTE_ERROR_500} element={<Error500Page />} />
      <Route path={RouteConstants.ROUTE_ERROR_503} element={<Error503Page />} />

      <Route path="*" element={<Error404Page />} />
    </Routes>
  )
}

export default CustomRouter;